<template>
  <div>
    <el-card class="box-card" style="margin-top: 10px">
      <div slot="header" class="clearfix">
        <span>体力索要配置</span>
      </div>
      <el-form>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="是否开放" style="margin-top: 35px;">
              <el-select v-model.number="spin.isOpen" placeholder="请选择">
                <el-option
                  v-for="item in openArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="登录天数">
              <el-input v-model.number="spin.loginDays" placeholder="登录天数" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="权重">
              <el-input v-model.number="spin.prob" placeholder="权重" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="索要最多体力">
              <el-input v-model.number="spin.moreSpins" placeholder="索要最多体力" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-button type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>

  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'Spin',
  data() {
    return {
      openArr: [
        { label: '关闭', value: 0 },
        { label: '开启', value: 1 }
      ],
      key: 'CLUB_CONFIG:SURPRISE:SPINS',
      spin: { 'isOpen': 1, 'loginDays': 1, 'prob': 100, 'moreSpins': 10 }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.spin = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.spin)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
